export { default as GradientBackground } from './gradient-background.svg';
export { default as ImageDisconnectCablesDark } from './disconnect-cables-dark.svg';
export { default as ImageDisconnectCablesLight } from './disconnect-cables-light.svg';
export { default as ImageDisconnectCablesDesktopDark } from './disconnect-cables-desktop-dark.svg';
export { default as ImageDisconnectCablesDesktopLight } from './disconnect-cables-desktop-light.svg';
